import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDanhSachLoaiNgayNghi } from '../../services/danhmuc';

const LoaiNgayNghiSelectBox = ({ value, optionAll, disabled, onChange }: { value?: number, optionAll?: boolean, disabled?: boolean, onChange: (e: any) => void }) => {
    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDanhSachLoaiNgayNghi();
            if (optionAll && rs.length > 1) {
                rs = [{ value: 0, label: "--Tất cả--" }, ...rs];
            };
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn loại ngày nghỉ--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            options={data}
            disabled={disabled}
            allowClear
            onChange={(e) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
        />
    );
};

export default LoaiNgayNghiSelectBox;
